import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

declare var process: any;

let appId: string | undefined;
let browserKey: string | undefined;
let accountId: string | undefined;
let agentId: string | undefined;
let trustKey: string | undefined;

try {
    appId = process.env.NEW_RELIC_APP_ID;
    browserKey = process.env.NEW_RELIC_BROWSER_KEY;
    accountId = process.env.NEW_RELIC_ACCOUNT_ID;
    agentId = process.env.NEW_RELIC_AGENT_ID;
    trustKey = process.env.NEW_RELIC_TRUST_KEY;
} catch (e) {
    // Fallback silencioso caso 'process' não seja injetado no navegador
}

if (appId && browserKey && accountId && agentId && trustKey) {
    const options = {
        info: {
            applicationID: appId as string,
            beacon: "bam.nr-data.net",
            errorBeacon: "bam.nr-data.net",
            licenseKey: browserKey as string,
            sa: 1
        },
        init: {
            ajax: {
                deny_list: ["bam.nr-data.net"]
            },
            browser_consent_mode: {
                enabled: false
            },
            distributed_tracing: {
                enabled: true
            },
            performance: {
                capture_detail: false,
                capture_marks: false,
                capture_measures: true
            },
            privacy: {
                cookies_enabled: true
            }
        },
        loader_config: {
            accountID: accountId as string,
            agentID: agentId as string,
            applicationID: appId as string,
            licenseKey: browserKey as string,
            trustKey: trustKey as string
        }
    };

    try {
        new BrowserAgent(options);
    } catch (e) {
        console.error('Failed to initialize New Relic Browser Agent:', e);
    }
} else {
    console.warn('New Relic Browser Agent not initialized: Missing configuration variables.');
}
